// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { agentControllerTypeGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    type: agentControllerTypeGuard,
    entityId: z.string().min(1).max(21),
    verifiedAt: z.number().nullable().optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    type: agentControllerTypeGuard,
    entityId: z.string().min(1).max(21),
    verifiedAt: z.number().nullable(),
    createdAt: z.number(),
});
export const AgentControllers = Object.freeze({
    table: 'agent_controllers',
    tableSingular: 'agent_controller',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        type: 'type',
        entityId: 'entity_id',
        verifiedAt: 'verified_at',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'type',
        'entityId',
        'verifiedAt',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
